export default {"src":"/_next/static/media/0xad84341756bf337f5a0164515b1f6f993d194e1f.aece7357.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};